import { useQuery } from 'hooks/useCustomQuery';
import getSRTRegionsForCompany from 'API/SRT/getSRTRegionsForCompany';
import { multiSelectDataMapper } from 'utils/utils';

/**
 * Regions selectable on the company's SRT service, mapped to select options.
 *
 * @param {object} params
 * @param {string} params.companyID
 */
const useGetSRTServiceRegions = ({ companyID }) => {
    return useQuery({
        queryKey: ['srtServiceRegions', companyID],
        queryFn: async () => {
            const result = await getSRTRegionsForCompany(companyID);
            return result.data.map(multiSelectDataMapper);
        },
        enabled: Boolean(companyID),
    });
};

export default useGetSRTServiceRegions;
